var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSparkle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 32.071a1 1 0 0 1-.966-.74l-.749-2.782a4.334 4.334 0 0 0-2.842-3l-1.826-.599a1 1 0 0 1 0-1.9l1.826-.6a4.334 4.334 0 0 0 2.842-3l.75-2.78a1 1 0 0 1 1.93 0l.75 2.78a4.334 4.334 0 0 0 2.842 3l1.826.6a1 1 0 0 1 0 1.9l-1.826.6a4.334 4.334 0 0 0-2.842 3l-.75 2.781a1 1 0 0 1-.965.74zM5.922 24A6.318 6.318 0 0 1 9 27.37 6.32 6.32 0 0 1 12.078 24 6.318 6.318 0 0 1 9 20.63 6.32 6.32 0 0 1 5.922 24zM20 24a1 1 0 0 1-.966-.74l-1.165-4.326a7.296 7.296 0 0 0-4.785-5.052l-2.84-.932a1 1 0 0 1 0-1.9l2.84-.932a7.297 7.297 0 0 0 4.785-5.052L19.034.74a1 1 0 0 1 1.932 0l1.165 4.326a7.297 7.297 0 0 0 4.784 5.052l2.84.932a1 1 0 0 1 0 1.9l-2.84.932a7.297 7.297 0 0 0-4.784 5.052l-1.165 4.326A1 1 0 0 1 20 24zm-6.238-12a9.292 9.292 0 0 1 6.039 6.413l.199.74.2-.74A9.292 9.292 0 0 1 26.236 12 9.292 9.292 0 0 1 20.2 5.587L20 4.847l-.2.74A9.292 9.292 0 0 1 13.763 12zM6 6a1 1 0 0 1-1-1V4a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zM4 8H3a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zM6 10.998a1 1 0 0 1-1-1v-1a1 1 0 0 1 2 0v1a1 1 0 0 1-1 1zM9 8H8a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2zM26 26a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zM24.001 28h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2zM26 30.998a1 1 0 0 1-1-1v-1a1 1 0 1 1 2 0v1a1 1 0 0 1-1 1zM28.999 28h-1a1 1 0 1 1 0-2h1a1 1 0 1 1 0 2z",
    fill: "#FFE082",
    opacity: 1,
    "data-original": "#FFE082",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSparkle);
export default __webpack_public_path__ + "static/media/sparkle.6a1436baa3c9b51befa81f2c332584f4.svg";
export { ForwardRef as ReactComponent };